var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniversityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.865609 2.95532L7.99938 0L15.1331 2.95532H0.865609ZM15.1349 3.48297H0.864271V4.40434H15.1349V3.48297ZM15.1349 11.2113H0.864271V12.1327H15.1349V11.2113ZM15.9996 12.5269H0V14H16L15.9996 12.5269ZM10.5929 10.8323V4.75886H8.69932V10.8323H10.5929ZM13.8862 10.8323V4.75886H11.9926V10.8323H13.8862ZM7.29983 10.8323V4.75886H5.40625V10.8323H7.29983ZM4.00658 10.8323V4.75886H2.113V10.8323H4.00658Z",
    fill: "#3C2166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityIcon);
export default __webpack_public_path__ + "static/media/university-icon.e2b8a0534c013ec74c50ac22214518b8.svg";
export { ForwardRef as ReactComponent };